import Vue from 'vue';
import axios from 'axios';
import VueI18n from 'vue-i18n';
import { Site, Language } from '@getaccept/lib-shared/src/languages/enums/translation';
import { TranslationHelper } from '@getaccept/lib-shared/src/languages/helpers/translation-setup.helper';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'en-default', // set locale
  fallbackLocale: Language.En,
  silentTranslationWarn: true,
});

export default i18n;
const fileUrl = process.env.LOKALISE_URL || 'https://translations.getaccept.com';
const project = Site.RecipientPage;
const loadedLanguages = []; // our default language that is preloaded

function setI18nLanguage(lang) {
  i18n.locale = lang;
  axios.defaults.headers.common['Accept-Language'] = lang;
  document.querySelector('html').setAttribute('lang', lang);
  return lang;
}

function getLangObject(lang: string, project: string): { key: string; id: string; file: string } {
  const languages = TranslationHelper.getLangObjectsForProject(project);

  const language: { key: string; id: string; file: string } = languages.find(
    language => language.id === lang
  );
  return language || languages.find(language => language.id === Language.En);
}

export async function loadLanguageAsync(lang: string): Promise<string | void> {
  if (i18n.locale === lang) {
    return Promise.resolve(lang);
  }
  if (loadedLanguages.includes(lang)) {
    return Promise.resolve(setI18nLanguage(lang));
  }

  const languageObj: { key: string; id: string; file: string } = getLangObject(lang, project);

  if (!window.location.href.includes('localhost')) {
    try {
      const { data } = await axios.get(`${fileUrl}/${project}/${languageObj.key}`);
      i18n.setLocaleMessage(lang, data);
      loadedLanguages.push(lang);
      return setI18nLanguage(lang);
    } catch (error) {
      console.error(error);
    }
  }

  return import(/* webpackChunkName: "lang-[request]" */ `./i18n/generated/${languageObj.file}`)
    .then(msgs => {
      i18n.setLocaleMessage(lang, msgs.default);
      loadedLanguages.push(lang);
      return setI18nLanguage(lang);
    })
    .catch(e => {
      console.error(e);
    });
}

export function userLanguage(): string {
  try {
    const lang = window.navigator['userLanguage'] || window.navigator.language;
    return lang.substring(0, 2);
  } catch (e) {
    return Language.En;
  }
}
